module.exports = __webpack_public_path__ + "img/Large-Horizontal-Rectangular-Attachment-25.cbf6a49a.png";